export default __webpack_public_path__ + "static/media/2690.6dfc1961.png";